import { ArrowLeftRight, CandlestickChart, Home, LayoutGrid, Settings, Telescope, type LucideIcon } from 'lucide-react'

export interface NavItem {
  to: string
  key: 'home' | 'markets' | 'convert' | 'forecasts' | 'more' | 'settings'
  icon: LucideIcon
}

export const PRIMARY_NAV: NavItem[] = [
  { to: '/', key: 'home', icon: Home },
  { to: '/markets', key: 'markets', icon: CandlestickChart },
  { to: '/convert', key: 'convert', icon: ArrowLeftRight },
  { to: '/forecasts', key: 'forecasts', icon: Telescope },
]

export const SETTINGS_NAV: NavItem = { to: '/settings', key: 'settings', icon: Settings }

export const MOBILE_NAV: NavItem[] = [
  PRIMARY_NAV[0]!,
  PRIMARY_NAV[1]!,
  PRIMARY_NAV[2]!,
  PRIMARY_NAV[3]!,
  { to: '/more', key: 'more', icon: LayoutGrid },
]
